import React, {useEffect, useState} from "react";
import "./VisitLogTable.sass"
import DialogComponent from "../../../common/dialog/DialogComponent";
import {useDispatch, useSelector} from "react-redux";
import {IDLE, LOADING} from "../../../../common/statuses";
import _ from "lodash";
import HMobiledataIcon from "@mui/icons-material/HMobiledata";
import CheckIcon from "@mui/icons-material/Check";
import {CropSquare} from "@mui/icons-material";
import {closeLesson} from "../../../../_actions/group/groupService";

export const VisitLogDialog = ({isOpen, onClose}) => {

    const [visits, setVisits] = useState({});

    const {data, status} = useSelector(state => state.groups.getLog);
    const {data: group} = useSelector(state => state.groups.selected)

    const dispatch = useDispatch();

    useEffect(() => {
        if (data) {
            const currentVisits = data.visits.filter(v => v.lesson.id === group.lesson.id);
            const res = {}
            currentVisits.map(v => {
                const {id, firstName, lastName, middleName} = v.student;
                res[v.id] = {
                    id: v.id,
                    isVisited: v.isVisited,
                    sortName: `${lastName} ${firstName} ${middleName} ${id}`,
                    name: `${lastName} ${firstName}`
                }
            })

            setVisits(res)
        }
    }, [data])

    if (status === IDLE || status === LOADING
        || _.isEmpty(data) || _.isEmpty(data.visits) || _.isEmpty(visits)) {
        return;
    }

    const getValue = (visit) => {
        if (visit.isVisited === false) {
            return <HMobiledataIcon/>
        } else if (visit.isVisited === true) {
            return <CheckIcon/>
        }
    }

    const handleClick = (id) => {
        let newValue;
        if (visits[id].isVisited === null) {
            newValue = true;
        } else if (visits[id].isVisited) {
            newValue = false
        } else {
            newValue = null;
        }

        const res = {
            ...visits,
            [id]: {
                ...visits[id],
                isVisited: newValue
            }
        }

        setVisits(res);
    }
    
    const handleSave = () => {
        const notMarked = Object.values(visits).filter(v => v.isVisited === null);

        if (_.isEmpty(notMarked)) {
            dispatch(closeLesson({
                lessonId: group.lesson.id,
                body: Object.values(visits),
            }))
        }
    }

    return (
        <DialogComponent title={"Необходимо отметить присутствующих"}
                         onClose={onClose}
                         onAccept={() => handleSave()}
                         buttons={{
                             accept: "Завершить урок",
                             cancel: "Отмена",
                         }}
                         open={isOpen}>
            <div className="VisitLogDialog-items">
                {Object.values(visits).sort((a, b) => {
                    const aName = `${a.sortName}`
                    const bName = `${b.sortName}`
                    return aName.localeCompare(bName)
                }).map((visit) => {
                    return <div key={`dialog-visit-${visit.id}`}
                                className="VisitLogDialog-item">
                        <div className="VisitLogDialog-item-name">{visit.name}</div>
                        <div className="VisitLogDialog-item-value">
                            <div className={"VisitLogDialog-item-checkbox"}
                                 onClick={() => handleClick(visit.id)}>
                                {getValue(visit)}
                            </div>
                        </div>

                    </div>
                })}
                <div className="VisitLogDialog-items-legend">
                    <div>
                        <CheckIcon/> - присутствовал
                    </div>
                    <div>
                        <HMobiledataIcon/> - отсутствовал
                    </div>
                    <div>
                        <CropSquare/> - не указано
                    </div>
                </div>
            </div>

        </DialogComponent>
    )
}